<template>
  <Modal v-model="voidBillModal" width="600" :transfer="false" :mask-closable="false"
    :title="$t('key1004153')" @on-visible-change="voidBillChange">
    <h2 class="mb20 ml21">{{ $t('key1004155') }}</h2>
    <Form :model="voidBillForm" ref="voidBillForm" :rules="ruleValidate" :label-width="90" @submit.native.prevent>
      <Row style="width: 95%">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1004154')" prop="invalidReason">
            <Input v-model.trim="voidBillForm.invalidReason" :placeholder="$t('key1004151')"
              type="textarea" :autosize="{minRows: 6, maxRows: 10}">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="voidBillModal = false">{{ $t('key1000112') }}</Button>
      <Button type="error" @click="voidBillBtn">{{ $t('key1004156') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'voidBillModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      voidBillModal: false,
      ymsPickupOrderId: null,
      voidBillForm: {
        invalidReason: ''
      },
      ruleValidate: {
        invalidReason: {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004151'), trigger: 'blur'}
      }
    };
  },
  methods: {
    // 初始化数据
    initVoidBillData(ymsPickupOrderId) {
      this.ymsPickupOrderId = ymsPickupOrderId;
      this.voidBillModal = true;
    },
    // 确认作废
    voidBillBtn() {
      let v = this;
      let params = {
        ymsPickupOrderId: v.ymsPickupOrderId,
        invalidReason: v.voidBillForm.invalidReason
      };
      v.$refs['voidBillForm'].validate((valid) => {
        if (valid) {
          v.axios.post(api.post_ymsPickupOrder_invalid, params, {
            loading: true,
            loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')
          }).then(response => {
            if (response.data.code === 0) {
              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004152'));
              v.voidBillModal = false;
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    voidBillChange(value) {
      if (!value) {
        this.$refs['voidBillForm'].resetFields();
      }
    }
  }
};
</script>

<style lang="less">

</style>
